import { Address } from "gpc-shared-types";

interface Props {
  title: string;
  address: Partial<Address>;
}

const OrderDetailAddress = ({
  title,
  address: {
    firstName,
    lastName,
    address1,
    address2,
    country,
    zip,
    province,
    phone,
    city,
  },
}: Props) => (
  <div className="gpc__order-detail-col">
    {title && <div className="gpc__order-detail-header">{title}</div>}
    {firstName && (
      <div className="gpc__order-detail-item">{`${firstName} ${lastName}`}</div>
    )}
    <div className="gpc__order-detail-item">{address1}</div>
    {address2 && <div className="gpc__order-detail-item">{address2}</div>}
    <div className="gpc__order-detail-item">
      {`${city?.toUpperCase()}, ${province?.toUpperCase()} ${zip ?? ""}`}
    </div>
    {country && <div className="gpc__order-detail-item">{country}</div>}
    {phone && <div className="gpc__order-detail-item">{phone}</div>}
  </div>
);

export default OrderDetailAddress;
